// extracted by mini-css-extract-plugin
export default {"mainContainer":"styles_mainContainer__wjY7X","bottomContainer":"styles_bottomContainer__LSGqU","innerContainer":"styles_innerContainer__Dc9N5"};